
export const html = 'http://www.w3.org/1999/xhtml';
export const pls = 'http://www.w3.org/2005/01/pronunciation-lexicon';
export const ssml = 'http://www.w3.org/2001/10/synthesis';
export const svg = 'http://www.w3.org/2000/svg';
export const xlink = 'http://www.w3.org/1999/xlink';
